import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';

import './snackbar.css';

class SnackbarContainer extends React.Component {
    render() {
        return (
            <ToastContainer
                position="bottom-center"
                closeButton={false}
                autoClose={5000}
                hideProgressBar
                newestOnTop
                closeOnClick
                draggable={false}
                rtl={false}
                pauseOnHover
            />
        );
    }
}

class Snackbar {
    static renderContent = (message, closeToast, hideClose) => {
        return (
            <div className="col-xs-12">
                <div className={`${hideClose ? 'col-xs-12' : 'col-xs-10 col-sm-9 '} snackbar-content`}>{message}</div>
                {hideClose !== true && (
                    <div className="close-button-wrapper">
                        <div className="close-button-table">
                            <span className="close-button" onClick={closeToast}>
                                <FormattedMessage {...messages.close} />
                            </span>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    static error = (message, options, hideClose = false) => {
        let content = ({ closeToast }) => <div className="row snack-bar error-message">{Snackbar.renderContent(message, closeToast, hideClose)}</div>;
        let instance = toast.error(content, options);
        if (!options || options.autoClose === undefined || options.autoClose === true) {
            setTimeout(() => toast.dismiss(instance), 5000);
        }
    };

    static success = (message, options, hideClose = false) => {
        let content = ({ closeToast }) => <div className="row snack-bar success-message">{Snackbar.renderContent(message, closeToast, hideClose)}</div>;
        let instance = toast.success(content, options);
        if (!options || options.autoClose === undefined || options.autoClose === true) {
            setTimeout(() => toast.dismiss(instance), 5000);
        }
    };
}

export { Snackbar, SnackbarContainer };



// WEBPACK FOOTER //
// ./src/components/snackbar/index.jsx